export default "__VITE_ASSET__DGLKqnwU__"